export default __webpack_public_path__ + "static/back-office-presentation-by-756948240b22a3026bdde4665f056dff.png";